module.exports = __webpack_public_path__ + "img/academyBg1.725c0102.jpg";